import { DialogTitle } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { DialogContent, Stack } from '@mui/material';
import { memo, useEffect } from 'react';
import { DialogFooter } from './components/dialog-footer';
import { ImportantNote } from './components/important-note';
import { PlanConfirmation } from './components/plan-confirmation';
import { StatusCard } from './components/status-card';
import * as Styled from './styles';
import * as SX from './sx';
import type { CancelPlanResultDialogProps as Props } from './types';

export const CancelPlanResultDialog = memo(
  ({ className, activeModal, closeModal, onCancel, onConfirm }: Props) => {
    const state = useBoolean(false);

    useEffect(() => {
      state.setValue(window.location.hash.includes('#successCancelDowngrade'));
    }, [window.location.hash, activeModal, state]);

    return (
      <Styled.Wrapper
        open={state.value}
        onClose={closeModal}
        className={classnames('CancelPlanResultDialog', className)}
        sx={SX.root}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle title="👋🏻 Downgrade Canceled" />
        <DialogContent>
          <Stack gap={1}>
            <StatusCard />
            <Stack sx={SX.content} gap={1}>
              <PlanConfirmation />
              <ImportantNote />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogFooter
          closeModal={closeModal}
          onCancel={onCancel}
          onConfirm={state.onFalse}
        />
      </Styled.Wrapper>
    );
  }
);

CancelPlanResultDialog.displayName = 'CancelPlanResultDialog';
